import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categoryData, categorySlugs } from '@/mocks/category';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'dianshiju');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const currentData = categoryData[activeSlug as keyof typeof categoryData] || categoryData.dianshiju;

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: currentData.name },
            ]}
          />
        </div>

        <section className="pb-14 md:pb-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                {currentData.name}
              </h1>
              <p className="text-foreground-500 text-sm md:text-base">
                {currentData.description}
              </p>
            </div>

            <div className="flex items-center gap-1 overflow-x-auto pb-2 mb-8 scrollbar-hide">
              <div className="flex items-center bg-background-100 rounded-full px-1 py-1">
                {categorySlugs.map((catSlug) => {
                  const catInfo = categoryData[catSlug as keyof typeof categoryData];
                  return (
                    <Link
                      key={catSlug}
                      to={`/category/${catSlug}`}
                      onClick={() => setActiveSlug(catSlug)}
                      className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                        activeSlug === catSlug
                          ? 'bg-primary-500 text-background-50'
                          : 'text-foreground-500 hover:text-foreground-800'
                      }`}
                    >
                      {catInfo.name}
                    </Link>
                  );
                })}
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {currentData.items.map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                        {item.rating}
                      </span>
                    </div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-background-50/80 text-xs">{item.platform}</span>
                    </div>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400">{item.info}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}